<div class="d-flex flex-column align-items-center">
  <div class="spinner-border review-spinner" style="color:#2730E3; width: 3rem; height: 3rem; z-index: 1002;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

